<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">
      <div class="d-flex justify-space-between" style="width: 100%">
        <div>
          {{ error.error_type }}
        </div>
        <v-btn icon color="red" @click="$emit('delete-error', error.path)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-card-title>

    <v-card-text>
      <div class="d-flex justify-space-between my-3">
        <GroupedChip left="ID" left-color="primary" :right="error.order_id" />
        <GroupedChip
          left="Date"
          left-color="primary"
          :right="error.order_date"
        />
      </div>
      <div class="d-flex justify-space-between my-3">
        <GroupedChip left="Kitchen" left-color="red" :right="error.kitchen" />
        <GroupedChip left="Platform" left-color="red" :right="error.platform" />
        <GroupedChip left="Concept" left-color="red" :right="error.concept" />
      </div>
      <div class="d-flex justify-space-between my-3">
        <GroupedChip left="Source" :right="error.original_topic" />
        <GroupedChip left="Function" :right="error.function_name" />
      </div>
      <div>
        <div class="title">Message</div>
        <div class="additional-fields">
          <div class="additional-fields-content">{{ error.details }}</div>
        </div>
      </div>
      <div>
        <div class="title">Details</div>
        <div class="additional-fields">
          <div class="additional-fields-content">
            {{ error.additional_fields }}
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="blue" text @click="retry('source')" x-small>
        Retry this step
        <v-icon right x-small>
          mdi-cloud-upload
        </v-icon>
      </v-btn>
      <v-btn color="blue" text @click="retry('original')" x-small>
        Retry from the beginning
        <v-icon right x-small>
          mdi-cloud-upload
        </v-icon>
      </v-btn>
      <v-btn
        rounded
        dark
        class="ma-1"
        small
        color="warning"
        @click="openContent(error.original_path)"
        >See original message</v-btn
      >
      <v-btn
        rounded
        dark
        class="ma-1"
        small
        color="warning"
        @click="openContent(error.source_path)"
        >See last message</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import GroupedChip from "./GroupedChip";

export default {
  components: {
    GroupedChip,
  },
  props: {
    error: { type: Object },
  },
  methods: {
    retry(type) {
      switch (type) {
        case "original":
          this.$emit(
            "retry",
            this.error.original_path,
            this.error.original_topic,
            this.error.path
          );
          break;
        case "source":
          this.$emit(
            "retry",
            this.error.source_path,
            this.error.source_topic,
            this.error.path
          );
          break;
      }
    },
    openContent(path) {
      this.$emit("open-content", path);
    },
  },
};
</script>

<style scoped lang="scss">
.additional-fields {
  border-radius: 10px;
  border: 1px solid black;
}
.additional-fields-content {
  max-height: 300px;
  overflow-y: auto;
  margin: 5px;
}
</style>
